import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { abandonProcessingSession } from "./schema/abandon-processing-session";
import { completeProcessingSession } from "./schema/complete-processing-session";
import { createProcessingSession } from "./schema/create-processing-session";
import { findOrCreateInventoryItemForLicensePlating } from "./schema/find-or-create-inventory-item-for-license-plating";
import { generateLicensePlate } from "./schema/generate-license-plate";
import { getPrinters } from "./schema/get-printers";
import { getProcessingSession } from "./schema/get-processing-session";
import { getReturnForProcessing } from "./schema/get-return-for-processing";
import { printLicensePlate } from "./schema/print-license-plate";
import { updateProcessingSessionItem } from "./schema/update-processing-session-item";

export const rpcDefinition = {
  getReturnForProcessing,
  getProcessingSession,
  createProcessingSession,
  updateProcessingSessionItem,
  completeProcessingSession,
  abandonProcessingSession,
  generateLicensePlate,
  findOrCreateInventoryItemForLicensePlating,
  printLicensePlate,
  getPrinters,
};

export type RedoReturnsProcessingRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
